module.exports = __webpack_public_path__ + "static/media/tree.e72831eb.jpg";